module.exports = __webpack_public_path__ + "static/img/s93.856178d7.png";